import React from 'react';

const TopBar = ({ onToggle }) => {
  return (
    <div className="topbar">
      <div className="hamburger" onClick={onToggle}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div style={{ color: '#fff', fontWeight: 600 }}>ShowNewLogic</div>
    </div>
  );
};

export default TopBar;
